import React, { useEffect, useState } from 'react';
import './TableDetailsGrid.css';
import BasicCli from '../../../main/components/basicCli/BasicCli';
import EditModal from '../../../main/components/modal/edit/EditModal';
import eFormType from '../../../main/assets/enums/eFormType';
import DeleteModal from '../../../main/components/modal/delete/DeleteModal';
import { ApiConstants } from '../../../main/constants/ApiConstants';
import ITable from '../../../main/interfaces/ITable';
import TableInventory from '../tableInventory/TableInventory';
import IRow from '../../../main/interfaces/IRow';
import IGridItems from '../../../main/interfaces/IGridItems';
import IPagination from '../../../main/interfaces/IPagination';
import RowsManager from '../../rows/rowsManager/RowsManager';
import axiosInstance from '../../../main/initializers/axios';
import GeneralTable from '../../../main/components/grid/GeneralTable';
import RightPanel from '../../../main/components/rightPanel/RightPanel';
import { useTranslation } from 'react-i18next';

const TableDetailsGrid = () => {
  const [tables, setTables] = useState<ITable[]>([]);
  const [gridItems, setGridItems] = useState<IGridItems[]>([]);
  const [rows, setRows] = useState<IRow[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRowShown, setRowShown] = useState(false);
  const [isModalEditOpen, setIsModalEditOpen] = useState(false);
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(0);
  const [aproved, setAproved] = useState(false);
  const [selectedVal, setSelectedVal] = useState<ITable | null>(null);
  const [pagination, setPagination] = useState<IPagination>({ count: 1, page: 1, itemPerPage: 50, itemsPerPage: [10, 20, 50, 100] });

  const { i18n } = useTranslation();

  const getRows = () => {
    axiosInstance.get(ApiConstants.row.list + '?rowType=2').then((res) => {
      setRows(res.data);
    });
  };

  const handleEdit = (item: ITable) => {
    setSelectedVal(item);
    setIsModalEditOpen(true);
  };

  const handleDelete = (item: ITable) => {
    setSelectedVal(item);
    setIsModalDeleteOpen(true);
  };

  const deleteDataSet = (id: number) => {
    axiosInstance.post(ApiConstants.tables.delete, { Id: id }).then(() => {
      setIsModalDeleteOpen(false);
      setTables((prev) => prev.filter((el: any) => el.id !== id));
    });
  };

  const selectedItemPagination = (item: IPagination) => {
    setPagination(item);
    getTable(0, item);
  };

  const getTable = (rowId: number | null, pagOverride?: IPagination, gridOverride?: IGridItems[]) => {
    const effectivePagination = pagOverride ?? pagination;
    const effectiveGrid = gridOverride ?? gridItems ?? [];

    axiosInstance.post(ApiConstants.tables.listCt, { gridItems: effectiveGrid, pagination: effectivePagination }).then((data) => {
      let listTable = data.data.items;
      if (rowId != null && rowId !== 0) {
        listTable = data.data.items.filter((x: ITable) => x.rowId === rowId);
      }

      setPagination((prev) => ({
        ...prev,
        count: data.data.pagination.count ?? prev.count,
        page: data.data.pagination.page ?? prev.page,
        itemPerPage: data.data.pagination.itemPerPage ?? prev.itemPerPage,
      }));
      setTables(listTable);
      setGridItems(data.data.gridItems);
    });
  };

  useEffect(() => {
    getTable(0);
    getRows();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const rowId = Number(event.target.value);
    setSelectedRowId(rowId);
    getTable(rowId);
  };

  return (
    <BasicCli>
      <div className="tdgWrap bcPageContent">
        <div className="tdgContainer">
          <div className="bcPageHeader">
            <h1 className="bcPageTitle">{i18n.t('tableDetails.tabbleListing')}</h1>
            <div className="HeaderActions">
              <select className="ui-control ui-select tdgRowSelect" value={selectedRowId} onChange={handleChange}>
                <option key="0" value="0">
                  {i18n.t('generic.-select-')}
                </option>
                {rows.map((item, index) => (
                  <option key={index} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
              <button className="ui-control ui-btn ui-btn--primary" type="button" onClick={() => setIsModalOpen(true)}>
                {i18n.t('tableDetails.addTabble')}
              </button>
              <button className="ui-control ui-btn ui-btn--secondary" type="button" onClick={() => setRowShown((s) => !s)}>
                {i18n.t('generic.addRows')}
              </button>
            </div>
          </div>

          <RightPanel isOpen={isRowShown} size={50} type="right" onKill={() => setRowShown((s) => !s)} backdropClicked={() => setRowShown((s) => !s)}>
            <RowsManager header={i18n.t('generic.addRows')} isOrder={false} handleClick={() => getRows()} rowType={2} />
          </RightPanel>

          <div className=" tdgTable">
            <GeneralTable
              data={tables}
              columns={gridItems}
              gridEntity={1}
              title=""
              hasRp={true}
              selectedItem={(val) => {
                setSelectedVal(val);
              }}
              onEdit={handleEdit}
              onDelete={handleDelete}
              pagination={pagination}
              selectedItemPagination={(val) => {
                selectedItemPagination(val);
              }}
              onFilterClose={(nextGridItems) => {
                setGridItems(nextGridItems);
                getTable(selectedRowId || 0, undefined, nextGridItems);
              }}
            />
          </div>

          {isModalEditOpen ? (
            <EditModal
              title={i18n.t('tableDetails.editTabble')}
              width="1024"
              closeModal={() => {
                setIsModalEditOpen(false);
              }}
              onSubmitData={() => {
                setAproved(true);
              }}
              setIsModalOpen={setIsModalEditOpen}
              modalType={eFormType.Edit}
            >
              <TableInventory
                tempProduct={selectedVal}
                rows={rows}
                createOrUpdate={aproved}
                modalType={eFormType.Edit}
                onSubmitData={() => {
                  getTable(0);
                  setIsModalEditOpen(false);
                  setAproved(false);
                }}
              />
            </EditModal>
          ) : null}

          {isModalDeleteOpen ? (
            <DeleteModal width="500px" handleClose={() => setIsModalDeleteOpen(false)} handleDelete={() => deleteDataSet(selectedVal?.id ?? 0)}>
              {i18n.t('generic.wantToDelete')}
              <strong className="text-danger"> {selectedVal?.name}</strong> {i18n.t('generic.code')} ({selectedVal?.name})ã€‚
            </DeleteModal>
          ) : null}

          {isModalOpen ? (
            <EditModal
              title={i18n.t('tableDetails.addTabble')}
              width="80%"
              closeModal={() => setIsModalOpen(false)}
              onSubmitData={() => {
                setAproved(true);
              }}
              setIsModalOpen={setIsModalOpen}
              modalType={eFormType.New}
            >
              <TableInventory
                rows={rows}
                modalType={eFormType.New}
                createOrUpdate={aproved}
                onSubmitData={() => {
                  getTable(0);
                  setAproved(false);
                }}
              />
            </EditModal>
          ) : null}
        </div>
      </div>
    </BasicCli>
  );
};

export default TableDetailsGrid;
